var $94a7d66dc3893f24$exports = {};
$94a7d66dc3893f24$exports = {
    "close": `Cerrar`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} notificaci\xf3n`,
            other: ()=>`${formatter.number(args.count)} notificaciones`
        })}.`
};


export {$94a7d66dc3893f24$exports as default};
//# sourceMappingURL=es-ES.mjs.map
